// src/services/deliveryService.js

import { API_ROUTES } from '../config/apiRoutes';

/**
 * دریافت لیست سفارشات در انتظار تحویل
 */
export const getDeliveries = async (params = null) => {
    const response = await API_ROUTES.GET_DELIVERIES(params);
    return response.data;
    // خروجی شامل: { success, message, data } مستقیم از سرور
};

/**
 * ثبت دریافتی (Multi-part برای عکس و دیتای فرم)
 */
export const registerReceipt = async (formData) => {
    const response = await API_ROUTES.REGISTER_RECEIPT(formData);
    return response.data;
};

/**
 * تأیید تحویل یا برگشت سفارش
 */
export const confirmDeliveryAction = async (formData) => {
    const response = await API_ROUTES.ACTION(formData);
    return response.data;
};

/**
 * جستجوی سفارشات تحویل
 */
export const searchDeliveries = async (searchParams) => {
    const response = await API_ROUTES.SEARCH(searchParams);
    return response.data;
};

/**
 * دریافت جزئیات یک سفارش تحویل
 */
export const getDeliveryDetails = async (deliveryId) => {
    const response = await API_ROUTES.DETAILS(deliveryId);
    return response.data;
};

/**
 * آپدیت وضعیت تحویل (تغییر زمان تحویل)
 */
export const updateDeliveryStatus = async (deliveryId, updateData) => {
    const response = await API_ROUTES.UPDATE(deliveryId, updateData);
    return response.data;
};

/**
 * لغو تحویل سفارش
 * نکته: منطق تاییدیه (Confirm) باید در کامپوننت/هوک هندل شود و دیگر در سرویس نیست.
 */
export const cancelDelivery = async (deliveryId, reason) => {
    const response = await API_ROUTES.CANCEL(deliveryId, reason);
    return response.data;
};

/**
 * دریافت گزارش تحویل‌ها
 */
export const getDeliveryReport = async (filters) => {
    const response = await API_ROUTES.REPORT(filters);
    return response.data; // شامل دیتا و فیلد meta ارسالی از لاراول
};

/**
 * عملیات دسته‌جمعی تایید تحویل
 */
export const bulkConfirmDelivery = async (deliveryIds) => {
    const response = await API_ROUTES.BULK_CONFIRM(deliveryIds);
    return response.data;
};

export default {
    getDeliveries,
    registerReceipt,
    confirmDeliveryAction,
    searchDeliveries,
    getDeliveryDetails,
    updateDeliveryStatus,
    cancelDelivery,
    getDeliveryReport,
    bulkConfirmDelivery
};